localizeCount = require 'lib/localize-count'
React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_bulk_actions')

module.exports = class extends React.Component
  render: t.renderable ->
    { bulkActionButtonText, count, onClose, onBulkActionPopoverClick, hasTeams, totalCount } = @props

    t.div =>
      t.div '.enterprise-bulk-actions .enterprise-button-bar',
        class: t.classify
          'has-selected-items': @props.hasSelectedItems && !@props.loading
      , =>
        t.div '.v-centered', =>
          if count > 0
            t.span -> t.text localizeCount('selected', count)

          t.span '.select-links', =>
            if !@props.allItemsAreSelected
              t.a '.select-all.clickable', onClick: @props.onSelectAll, ->
                t.format 'select-all'
            if @props.hasSelectedItems
              t.a '.clear-all.clickable', onClick: @props.onClearAll, ->
                t.format 'clear'

        if count > 0
          t.div '.options', =>
            if hasTeams
              t.b onBulkActionPopoverClick,
                '.option.button-link.role-button',
                class: t.classify(disabled: !@props.hasSelectedItems)
                disabled: !@props.hasSelectedItems
              , ->
                t.format bulkActionButtonText



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/bulk-actions-component.coffee